import { useLazyQuery } from '@apollo/client'

import { QUERY_ACCOUNT } from '~/modules/account/queries'

/**
 *
 */
export default function useAccount() {
  const [queryAccount, { data, error, loading, refetch }] =
    useLazyQuery(QUERY_ACCOUNT)

  return {
    account: data ? data.account : null,
    queryAccount,
    queryAccountStatus: { loading, error, refetch },
  }
}
